import { useEffect, useState } from "react";
import { useMollie } from "./useMollie";

const loadedComponents: { [key: string]: unknown } = {};

function useMollieComponent(type: string): { mollieComponent: unknown } {
  const { mollie } = useMollie() as { mollie: any | undefined };
  const [mollieComponent, setMollieComponent] = useState<unknown>();

  useEffect(() => {
    if (mollie) {
      if (!loadedComponents[type]) {
        // Create the requested component if it doesn't exist yet
        loadedComponents[type] = mollie?.createComponent(type);
      }
      setMollieComponent(loadedComponents[type]);
    }
  }, [type, mollie]);

  return { mollieComponent };
}

export { useMollieComponent };
